import type {
  PaginatedPassengerAddressList,
  PassengerAddress,
} from '@bambi/api-client/schemas';
import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export default function getRecentAddressesAsOptions(
  recentAddressResponse: PaginatedPassengerAddressList | undefined
): SelectOption[] {
  return (
    recentAddressResponse?.results.map((result) => ({
      label: getLabelForAddress(result),
      value: result.address.location?.place_id || '',
    })) || []
  );
}

function getLabelForAddress(address: PassengerAddress): string {
  if (!address.address.location?.label) {
    return '';
  }

  const name = address.name;
  if (name) {
    return `(${name}) ${address.address.location.label}`;
  }
  return address.address.location.label;
}
